import {UI} from "../../../../../../stem-core/src/ui/UIBase";
import {StyleSheet} from "../../../../../../stem-core/src/ui/Style";
import {Messages} from "../../../../../Messages";
import {styleRule} from "../../../../../../stem-core/src/decorators/Style";
import {registerStyle} from "../../../../../../stem-core/src/ui/style/Theme";
import {CheckboxInput} from "../../../../../../core/ui/input/checkbox/CheckboxInput.jsx";
import {NOOP_FUNCTION} from "../../../../../../stem-core/src/base/Utils";
import {CardForm} from "./CardForm.jsx";
import {iFrameMerchantService} from "blinkpay/services/IframeMerchantService";
import {Controller} from "../../../../Controller";


export class PayWithAddedCardComponentStyle extends StyleSheet {
    @styleRule
    title = this.themeProps.PANEL_TITLE;

    @styleRule
    checkbox = {
        ...this.themeProps.INLINE_DONATE_FLOW_CHECKBOX,
        marginBottom: 0,
    };
}

@registerStyle(PayWithAddedCardComponentStyle)
export class PayWithAddedCardComponent extends UI.Element {
    getDefaultOptions() {
        return {
            onChange: NOOP_FUNCTION,
            testId: "payWithAddedCard",
            title: Messages.payWithAddedCardComponentTitle
        };
    }

    render() {
        const {styleSheet} = this;
        const {title} = this.options;

        return [
            <div className={styleSheet.title}>{title}</div>,
            <CardForm ref="cardForm" onChange={this.options.onChange}/>,
            !iFrameMerchantService.isCDSPaymentMethod() && Controller.paymentMethod.showSaveCardCheckbox ?
                <CheckboxInput ref="storeCardCheckbox"
                                 testId="storeCardCheckbox"
                                 className={styleSheet.checkbox}
                                 initialValue={Controller.paymentMethod.savePaymentMethod}
                                 label={Messages.saveCardDetailsCheckbox}
                                 onChange={enabled => Controller.paymentMethod.update({savePaymentMethod: enabled})}/> : null
        ];
    }

    isValid() {
        return this.cardForm.isValid();
    }

    getPaymentMethodId(scope, callback, errorCallback) {
        if (this.storeCardCheckbox && this.storeCardCheckbox.getValue()) {
           this.cardForm.confirmCard(card => callback(card.id), errorCallback);
        } else {
             if (iFrameMerchantService.isCDSPaymentMethod()) {
                 this.cardForm.confirmCardWithoutStoring(scope, card => callback(card), errorCallback);
            } else {
                 this.cardForm.confirmCardWithoutStoring(scope, card => callback(card.id), errorCallback);
            }
        }
    }
}
